// src/app/navigation/admin-mobile-header/admin-mobile-header.component.ts
import { Component, EventEmitter, Output, computed, inject } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { XdsIconButtonComponent } from 'src/app/shared/ui';
import { XdsPageContextService } from 'src/app/shared/ui/a11y/page-context.service';
import { XdsViewportService } from 'src/app/shared/ui/a11y/viewport.service';
import { TopActionsBarComponent } from '../top-actions-bar/top-actions-bar.component';

@Component({
    selector: 'app-admin-mobile-header',
    templateUrl: './admin-mobile-header.component.html',
    styleUrls: ['./admin-mobile-header.component.css'],
    imports: [
        CommonModule,
        TranslateModule,
        XdsIconButtonComponent,
        MatDialogModule,
        TopActionsBarComponent
    ]
})
export class AdminMobileHeaderComponent {
  @Output() menuToggle = new EventEmitter<void>();

  private readonly pageContext = inject(XdsPageContextService);
  private readonly viewport = inject(XdsViewportService);

  /**
   * Titel/Untertitel der offenen Fläche, wie der Seitenkopf sie gemeldet hat.
   * Die Komponente rendert nur — sie fragt nicht die Route ab (das wäre eine zweite
   * Quelle neben den `titleKey`-Werten der Seitenköpfe).
   */
  readonly context = this.pageContext.context;

  /** Frei gesetzte Kontextzeile der Fläche, z. B. „KW 37 · 7.–13. Sep". */
  readonly contextText = this.pageContext.contextText;

  /**
   * Zeigt der Kopf den Seitennamen statt der Marke?
   *
   * Nur am Telefon, und nur wenn eine Fläche überhaupt einen Titel gemeldet hat.
   * Der zweite Teil ist der Rückfall, der eine Routen-Allowlist erspart: Flächen
   * ohne `xds-page-header` (und es gibt sie) behalten das Logo, statt einen leeren
   * Kopf zu zeigen.
   *
   * ⚠️ **Die Marke weicht damit auf dem Telefon dem Seitennamen** — eine bewusste
   * Entscheidung, keine Platznot: 360px tragen Hamburger, drei globale Aktionen und
   * EINEN von beiden. In einer angemeldeten App wiegt Orientierung schwerer als
   * Branding; die Marke steht weiterhin im Splash und in der Schublade.
   */
  readonly showsPageTitle = computed(
    () => this.viewport.deviceClass() === 'phone' && !!this.context()
  );

  constructor(private dialog: MatDialog) {}

  onMenuToggleClick(): void {
    // Close all open dialogs when opening the menu (fixes popup staying visible issue)
    this.dialog.closeAll();
    this.menuToggle.emit();
  }
}
